import Swiper from "swiper";

interface ISwiper extends Swiper {
    controller: object;
    lazy: object;
    realIndex: number;
    previousIndex: number;

    init(): void;

    on(event: string, callback: () => void);
}

interface ISwiperOptions extends SwiperOptions {
    navigation: any;
    pagination?: any;
    lazy: any;
    keyboard: any;
}

export class SliderComponent {
    public static SELECTOR = ".slider";

    public static autoInit(): SliderComponent[] {
        const sliders = document.querySelectorAll(this.SELECTOR) as NodeListOf<HTMLElement>;
        return Array.from(sliders).map((slider) => new this(slider));
    }

    protected sliderElement: HTMLElement;

    protected swiperInstance: ISwiper;
    protected swiperOptions: ISwiperOptions = {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        keyboard: {
            enabled: true,
            onlyInViewport: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        preloadImages: false,
        lazy: {
            loadPrevNext: true,
        },
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 0,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
            stopOnLastSlide: true,
        } as any,
    };

    constructor(slider: HTMLElement) {
        this.sliderElement = slider;

        this.createSwiper();
    }

    protected createSwiper(): void {
        this.swiperInstance = new Swiper(
            this.sliderElement,
            this.swiperOptions as any,
        ) as ISwiper;
    }
}



// WEBPACK FOOTER //
// ./components/slider/slider.component.ts